/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseFromJSON, FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResultFromJSON, FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestToJSON, FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseFromJSON, FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseFromJSON, FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandToJSON, FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestToJSON, FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponseFromJSON, FxIdWebFeaturesAuthAuthenticateFromFirebaseRequestToJSON, FxIdWebFeaturesAuthAuthenticateFromFirebaseResponseFromJSON, FxIdWebFeaturesAuthAuthenticateFromGameRequestToJSON, FxIdWebFeaturesAuthAuthenticateFromGameResponseFromJSON, FxIdWebFeaturesAuthAuthenticateFromImportRequestToJSON, FxIdWebFeaturesAuthAuthenticateFromImportResponseFromJSON, FxIdWebFeaturesAuthAuthenticateFromSocialRequestToJSON, FxIdWebFeaturesAuthAuthenticateFromSocialResponseFromJSON, FxIdWebFeaturesAuthAuthenticateFromTokenRequestToJSON, FxIdWebFeaturesAuthAuthenticateFromTokenResponseFromJSON, FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestToJSON, FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseFromJSON, FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestToJSON, FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseFromJSON, FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestToJSON, FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseFromJSON, FxIdWebFeaturesAuthCreateTempTokenRequestToJSON, FxIdWebFeaturesAuthCreateTempTokenResponseFromJSON, FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequestToJSON, FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseFromJSON, FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequestToJSON, FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthResponseFromJSON, FxIdWebFeaturesAuthOauthUserInfoResponseFromJSON, FxIdWebFeaturesAuthTwitchConnectRequestToJSON, FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestToJSON, } from '../models/index';
/**
 *
 */
export class AuthApi extends runtime.BaseAPI {
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user by email invite token
     */
    async fxIdWebFeaturesAuthAuthenticateFromEmailInviteEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest', 'Required parameter "fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromEmailInviteEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_email_invite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user by email invite token
     */
    async fxIdWebFeaturesAuthAuthenticateFromEmailInviteEndpoint(fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromEmailInviteEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest: fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user from facebook games
     */
    async fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpoint().');
        }
        if (requestParameters['fbLocale'] == null) {
            throw new runtime.RequiredError('fbLocale', 'Required parameter "fbLocale" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpoint().');
        }
        if (requestParameters['signedRequest'] == null) {
            throw new runtime.RequiredError('signedRequest', 'Required parameter "signedRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['fbLocale'] != null) {
            formParams.append('FbLocale', requestParameters['fbLocale']);
        }
        if (requestParameters['signedRequest'] != null) {
            formParams.append('SignedRequest', requestParameters['signedRequest']);
        }
        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_facebook_games/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user from facebook games
     */
    async fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpoint(game, fbLocale, signedRequest, initOverrides) {
        await this.fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpointRaw({ game: game, fbLocale: fbLocale, signedRequest: signedRequest }, initOverrides);
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user via firebase admin sdk
     */
    async fxIdWebFeaturesAuthAuthenticateFromFirebaseEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest', 'Required parameter "fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromFirebaseEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_firebase`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromFirebaseRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromFirebaseResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user via firebase admin sdk
     */
    async fxIdWebFeaturesAuthAuthenticateFromFirebaseEndpoint(fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromFirebaseEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest: fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using game\'s jwt token (JwtSecret)
     */
    async fxIdWebFeaturesAuthAuthenticateFromGameEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromGameRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthAuthenticateFromGameRequest', 'Required parameter "fxIdWebFeaturesAuthAuthenticateFromGameRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromGameEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_game`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromGameRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromGameRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromGameResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using game\'s jwt token (JwtSecret)
     */
    async fxIdWebFeaturesAuthAuthenticateFromGameEndpoint(fxIdWebFeaturesAuthAuthenticateFromGameRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromGameEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromGameRequest: fxIdWebFeaturesAuthAuthenticateFromGameRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`
     */
    async fxIdWebFeaturesAuthAuthenticateFromImportEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromImportRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthAuthenticateFromImportRequest', 'Required parameter "fxIdWebFeaturesAuthAuthenticateFromImportRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromImportEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromImportRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromImportRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromImportResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`
     */
    async fxIdWebFeaturesAuthAuthenticateFromImportEndpoint(fxIdWebFeaturesAuthAuthenticateFromImportRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromImportEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromImportRequest: fxIdWebFeaturesAuthAuthenticateFromImportRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using social network login
     */
    async fxIdWebFeaturesAuthAuthenticateFromSocialEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromSocialRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthAuthenticateFromSocialRequest', 'Required parameter "fxIdWebFeaturesAuthAuthenticateFromSocialRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromSocialEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_social`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromSocialRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromSocialRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromSocialResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using social network login
     */
    async fxIdWebFeaturesAuthAuthenticateFromSocialEndpoint(fxIdWebFeaturesAuthAuthenticateFromSocialRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromSocialEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromSocialRequest: fxIdWebFeaturesAuthAuthenticateFromSocialRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Authenticates user using temp jwt token
     */
    async fxIdWebFeaturesAuthAuthenticateFromTokenEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromTokenRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthAuthenticateFromTokenRequest', 'Required parameter "fxIdWebFeaturesAuthAuthenticateFromTokenRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromTokenEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_temp_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromTokenRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromTokenRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromTokenResponseFromJSON(jsonValue));
    }
    /**
     * Authenticates user using temp jwt token
     */
    async fxIdWebFeaturesAuthAuthenticateFromTokenEndpoint(fxIdWebFeaturesAuthAuthenticateFromTokenRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromTokenEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromTokenRequest: fxIdWebFeaturesAuthAuthenticateFromTokenRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using vk.com openapi
     */
    async fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest', 'Required parameter "fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_vkontaktecom_openapi`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using vk.com openapi
     */
    async fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiEndpoint(fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest: fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user from \'external id\' authentication (FxLauncher) to fxid
     */
    async fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest', 'Required parameter "fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/authenticate_to_fxid_adapter_for_external_id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user from \'external id\' authentication (FxLauncher) to fxid
     */
    async fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdEndpoint(fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdEndpointRaw({ fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest: fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesAuthAuthenticateToFxIdEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest'] == null) {
            throw new runtime.RequiredError('fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest', 'Required parameter "fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateToFxIdEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/auth/authenticate_to_fxid`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestToJSON(requestParameters['fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesAuthAuthenticateToFxIdEndpoint(fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthAuthenticateToFxIdEndpointRaw({ fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest: fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user for \'external id\' authentication (FxLauncher)
     */
    async fxIdWebFeaturesAuthAuthenticateWithExternalIdEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateWithExternalIdEndpoint().');
        }
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest', 'Required parameter "fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateWithExternalIdEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/authenticate_with_external_id/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user for \'external id\' authentication (FxLauncher)
     */
    async fxIdWebFeaturesAuthAuthenticateWithExternalIdEndpoint(game, fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthAuthenticateWithExternalIdEndpointRaw({ game: game, fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest: fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Получает токен из игры, и если игрок подключен, то выдает ему токен для fxid
     */
    async fxIdWebFeaturesAuthCreateTempTokenEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthCreateTempTokenRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthCreateTempTokenRequest', 'Required parameter "fxIdWebFeaturesAuthCreateTempTokenRequest" was null or undefined when calling fxIdWebFeaturesAuthCreateTempTokenEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/auth/create_temp_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthCreateTempTokenRequestToJSON(requestParameters['fxIdWebFeaturesAuthCreateTempTokenRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthCreateTempTokenResponseFromJSON(jsonValue));
    }
    /**
     * Получает токен из игры, и если игрок подключен, то выдает ему токен для fxid
     */
    async fxIdWebFeaturesAuthCreateTempTokenEndpoint(fxIdWebFeaturesAuthCreateTempTokenRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthCreateTempTokenEndpointRaw({ fxIdWebFeaturesAuthCreateTempTokenRequest: fxIdWebFeaturesAuthCreateTempTokenRequest }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesAuthLogoutEndpointRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/auth/logout`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async fxIdWebFeaturesAuthLogoutEndpoint(initOverrides) {
        await this.fxIdWebFeaturesAuthLogoutEndpointRaw(initOverrides);
    }
    /**
     */
    async fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest', 'Required parameter "fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest" was null or undefined when calling fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/oauth/mygames/info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequestToJSON(requestParameters['fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthEndpoint(fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthEndpointRaw({ fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest: fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Using mygames data to transfer account
     */
    async fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest', 'Required parameter "fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest" was null or undefined when calling fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/oauth/mygames/transfer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequestToJSON(requestParameters['fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Using mygames data to transfer account
     */
    async fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthEndpoint(fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthEndpointRaw({ fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest: fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts_connections`  Connects twitch account
     */
    async fxIdWebFeaturesAuthTwitchConnectEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthTwitchConnectRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthTwitchConnectRequest', 'Required parameter "fxIdWebFeaturesAuthTwitchConnectRequest" was null or undefined when calling fxIdWebFeaturesAuthTwitchConnectEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/auth/twitch/connect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthTwitchConnectRequestToJSON(requestParameters['fxIdWebFeaturesAuthTwitchConnectRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `social_identifiers`, `accounts_connections`  Connects twitch account
     */
    async fxIdWebFeaturesAuthTwitchConnectEndpoint(fxIdWebFeaturesAuthTwitchConnectRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthTwitchConnectEndpointRaw({ fxIdWebFeaturesAuthTwitchConnectRequest: fxIdWebFeaturesAuthTwitchConnectRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `social_identifiers`  Refreshes twitch\'s token
     */
    async fxIdWebFeaturesAuthTwitchRefreshAccessTokenEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest', 'Required parameter "fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest" was null or undefined when calling fxIdWebFeaturesAuthTwitchRefreshAccessTokenEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/auth/twitch/refresh_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestToJSON(requestParameters['fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `social_identifiers`  Refreshes twitch\'s token
     */
    async fxIdWebFeaturesAuthTwitchRefreshAccessTokenEndpoint(fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthTwitchRefreshAccessTokenEndpointRaw({ fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest: fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand'] == null) {
            throw new runtime.RequiredError('fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand', 'Required parameter "fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand" was null or undefined when calling fxIdWebFeaturesAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessToken().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/auth/validate-external-id-auth-game-access-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandToJSON(requestParameters['fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResultFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessToken(fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand, initOverrides) {
        const response = await this.fxIdWebFeaturesAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenRaw({ fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand: fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand }, initOverrides);
        return await response.value();
    }
    /**
     * ВНИМАНИЕ этот userInfo заточен на работу с AuthenticateWithExternalId GameAccess токенами Если вы хотите валидировать другие - сделайте рядом другой эндпоинт или добавьте query параметр
     */
    async getFxIdWebFeaturesAuthOauthUserInfoEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling getFxIdWebFeaturesAuthOauthUserInfoEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/auth/oauth/userinfo/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthOauthUserInfoResponseFromJSON(jsonValue));
    }
    /**
     * ВНИМАНИЕ этот userInfo заточен на работу с AuthenticateWithExternalId GameAccess токенами Если вы хотите валидировать другие - сделайте рядом другой эндпоинт или добавьте query параметр
     */
    async getFxIdWebFeaturesAuthOauthUserInfoEndpoint(game, initOverrides) {
        const response = await this.getFxIdWebFeaturesAuthOauthUserInfoEndpointRaw({ game: game }, initOverrides);
        return await response.value();
    }
    /**
     * ВНИМАНИЕ этот userInfo заточен на работу с AuthenticateWithExternalId GameAccess токенами Если вы хотите валидировать другие - сделайте рядом другой эндпоинт или добавьте query параметр
     */
    async postFxIdWebFeaturesAuthOauthUserInfoEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling postFxIdWebFeaturesAuthOauthUserInfoEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/auth/oauth/userinfo/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthOauthUserInfoResponseFromJSON(jsonValue));
    }
    /**
     * ВНИМАНИЕ этот userInfo заточен на работу с AuthenticateWithExternalId GameAccess токенами Если вы хотите валидировать другие - сделайте рядом другой эндпоинт или добавьте query параметр
     */
    async postFxIdWebFeaturesAuthOauthUserInfoEndpoint(game, initOverrides) {
        const response = await this.postFxIdWebFeaturesAuthOauthUserInfoEndpointRaw({ game: game }, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=AuthApi.js.map